
window.debug = {
	db : null,
	isDebug : false,
	start : function(){
		if(this.isDebug){
			return;
		}
		this.isDebug = true;
		this._todb();
		
	},
	end : function(){
		if(this.isDebug == false){
			return;
		}
		this.isDebug = false
		this._todb();
	},
	log : function(str){
		if(this.isDebug){
			console.log("%c " + str,"color:red");
		}
	},
	_todb : function(){
		var trans = this.db.transaction(["smartWorxDebugKey"],"readwrite");        
        var store =  trans.objectStore("smartWorxDebugKey");   
        var o = {
            "smartWorx": "EF3",
	        "isDebug": this.isDebug
        };    
        var request = store.put(o);
	}
}

Object.defineProperty(window, '__stack', {
    get: function(){
        var orig = Error.prepareStackTrace;
        Error.prepareStackTrace = function(_, stack){ return stack; };
        var err = new Error;
        Error.captureStackTrace(err, arguments.callee);
        var stack = err.stack;
        Error.prepareStackTrace = orig;
        return stack;
    }
});

Object.defineProperty(window, '__loginfo__', {
    get: function(){
        var path = __stack[2].getFileName();
        var files = path.split("\\");
        return {
            "no" : __stack[2].getLineNumber(),
            "file" : files[files.length - 1]
        };
    }
});

var openWinDB = function(){
	if (!window.indexedDB) {
	    console.warn("浏览器不支持 indexedDB 无法启动调试模块");
	}else{
		var request = window.indexedDB.open("smartWorxDB",1);
		request.onerror = function(event) {
			console.warn(" 打开indexedDB错误，无法启动调试模块");
		};
		request.onsuccess = function(event) {
		  	var db = event.target.result;
		  	window.debug.db = db;
		  	var trans = db.transaction(["smartWorxDebugKey"],"readwrite");        
	        var store =  trans.objectStore("smartWorxDebugKey");   

	        var index = store.index("smartWorx");
			index.get("EF3").onsuccess = function(event) {
				window.debug.isDebug = event.target.result.isDebug
			};
            
		};
		request.onupgradeneeded = function(e) {
	        var db = e.target.result;
	        if (!db.objectStoreNames.contains('smartWorxDB')) {
	            var objectStore = db.createObjectStore('smartWorxDebugKey',{"keyPath": "smartWorx"});
	            objectStore.createIndex("smartWorx", "smartWorx", { unique: true });
	            objectStore.add({"smartWorx" : "EF3","isDebug": false});
	        }
		}
		
	}
};
//清除 indexDB
window.delIndexDB = function(winName){
	if(winName){
		var transaction = window.indexDBId.transaction(['projectObject']);
    	var objectStore = transaction.objectStore('projectObject');
		var request = objectStore.getAll();
		request.onsuccess = async function(event) {
			for(var k in request.result ){
				for(var i in  request.result[k]){
					if([i][0] == winName){
						window.deleteNameIndexDB(request.result[k].id)
					}
				}
			}
		}.bind(this);
		return "按名称删除成功!"
	}else{
		var transaction = window.indexDBId.transaction(['projectObject'],"readwrite");
		var objectStore = transaction.objectStore('projectObject');
		objectStore.clear();

		return "清除表成功!"
	}
};
window.deleteNameIndexDB = function(winName){
	var transaction = window.indexDBId.transaction(['projectObject'],"readwrite");
	var objectStore = transaction.objectStore('projectObject');
	objectStore.delete(winName);
};
//重新创建查询数据 否则再ulr清除没有
window.getIndexDB = function(projectName,delName){
	var indexedDB =
		window.indexedDB ||
		window.webkitIndexedDB ||
		window.mozIndexedDB ||
		window.msIndexedDB;
	if (!indexedDB) {
		console.log('你的浏览器不支持IndexedDB');
	}
	// 2\. 通过IDBFactory接口的open方法打开一个indexedDB的数据库实例
	// 第一个参数： 数据库的名字，第二个参数：数据库的版本。返回值是一个：IDBRequest实例,此实例有onerror和onsuccess事件。
	var IDBOpenDBRequest = indexedDB.open(projectName, 1);
	// 3\. 对打开数据库的事件进行处理
	// 打开数据库成功后，自动调用onsuccess事件回调。
	IDBOpenDBRequest.onsuccess = function(e) {
		window.indexDBId = e.target.result;
		window.delIndexDB(delName);
		location.href = location.origin
		
	}.bind(this);

	// 打开数据库失败
	IDBOpenDBRequest.onerror = function(e) {
		console.log(e.currentTarget.error.message);
	}.bind(this);

	// 第一次打开成功后或者版本有变化自动执行以下事件：一般用于初始化数据库。
	IDBOpenDBRequest.onupgradeneeded = function(e) {
		if (!e.target.result.objectStoreNames.contains("projectObject")) {
			//如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
			// objectStore就相当于数据库中的一张表。IDBObjectStore类型。
			var objectStore = e.target.result.createObjectStore("projectObject", {
				keyPath: 'id',
				autoIncrement: true
			});
			
		}
		
	};
	
};
//创建系统
window.systemIndexDB = function(projectName,delName){
	var indexedDB =
		window.indexedDB ||
		window.webkitIndexedDB ||
		window.mozIndexedDB ||
		window.msIndexedDB;
	if (!indexedDB) {
		console.log('你的浏览器不支持IndexedDB');
	}
	// 2\. 通过IDBFactory接口的open方法打开一个indexedDB的数据库实例
	// 第一个参数： 数据库的名字，第二个参数：数据库的版本。返回值是一个：IDBRequest实例,此实例有onerror和onsuccess事件。
	var IDBOpenDBRequest = indexedDB.open("system", 1);
	// 3\. 对打开数据库的事件进行处理
	// 打开数据库成功后，自动调用onsuccess事件回调。
	IDBOpenDBRequest.onsuccess = function(e) {
		window.systemDBId = e.target.result;
		// window.delIndexDB(delName);
		// location.href = location.origin
		var transaction = window.systemDBId.transaction(["projectObject"], 'readwrite');
		// 通过事务来获取IDBObjectStore
		var store = transaction.objectStore("projectObject");
		var addPersonRequest = store.add({
			id:1,
			"tokey":""
		});
		// 监听添加成功事件
		addPersonRequest.onsuccess = function(e) {
			// console.log("创建tokey成功 id："+e.target.result); // 打印添加成功数据的 主键（id）
		};
		// 监听失败事件
		addPersonRequest.onerror = function(e) {
			// console.log("失败");
		};
		
	}.bind(this);

	// 打开数据库失败
	IDBOpenDBRequest.onerror = function(e) {
		console.log(e.currentTarget.error.message);
	}.bind(this);

	// 第一次打开成功后或者版本有变化自动执行以下事件：一般用于初始化数据库。
	IDBOpenDBRequest.onupgradeneeded = function(e) {
		if (!e.target.result.objectStoreNames.contains("projectObject")) {
			//如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
			// objectStore就相当于数据库中的一张表。IDBObjectStore类型。
			var objectStore = e.target.result.createObjectStore("projectObject", {
				keyPath: 'id',
				autoIncrement: true
			});
			
		}
		
	};
	
};
//清除所有表indexDB
window.delIndexDBAll =  function(){
	// var transaction = window.indexDBId.transaction(['projectObject'],"readwrite");
	// var objectStore = transaction.objectStore('projectObject');
	// objectStore.clear();
	//清除配置表
	var systemTransaction = window.systemDBId.transaction(['projectObject'],"readwrite");
	var systemObjectStore = systemTransaction.objectStore('projectObject');
	systemObjectStore.clear();
	return "配置表 清除表成功!"
};
systemIndexDB();



// WEBPACK FOOTER //
// ./src/debug.js